import React, { useMemo } from "react"
import { Toast, TOAST_HELPERS } from "../../entities/toasts/Toasts"
import { ToastActions } from "../../store/stores/toasts/Toasts.Actions"
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { AdventureEventComponent } from "../collection/adventures/adventure-events/AdventureEventComponent";
import { LocalAdventure } from "../../entities/adventures/Adventure";

type Props = {
    toast: Toast;
}

export const ToastComponent: React.FC<Props> = (props: Props) => {
    const { id, type, message } = props.toast;
    const adventures = useAppSelector(app => app.adventure.adventures);
    const { characters, otherPlayerCharacters } = useAppSelector(app => app.character);
    const { me, players } = useAppSelector(app => app.player);
    const library = useAppSelector(app => app.library);

    let adventure: LocalAdventure | undefined;
    const dispatch = useAppDispatch();
    if (TOAST_HELPERS.messageIsAdventureEvent(message)) {
        adventure = adventures.find(a => a.id == message.adventureId);
    }
    return (
        <div className={`toast ${type.toLowerCase()}`}>
            <i className='fas fa-exclamation-circle toast-icon'></i>
            {TOAST_HELPERS.messageIsString(message) && 
                <div>{message}</div>
            }
            {TOAST_HELPERS.messageIsAdventureEvent(message)
                && adventure
                && me
                && <AdventureEventComponent
                    adventure={adventure}
                    event={message}
                    players={[me, ...players]}
                    characters={[...characters, ...otherPlayerCharacters]}
                    entities={library}
                />
            }
            <button className="toast-close" onClick={() => dispatch(ToastActions.dismissToast(id))}>
                <span className='material-symbols-outlined'>cancel</span>
            </button>
        </div>
    );
}